import { render, staticRenderFns } from "./shop-checkouts.vue?vue&type=template&id=abfb75a2&"
import script from "./shop-checkouts.vue?vue&type=script&lang=js&"
export * from "./shop-checkouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports